export default "__VITE_ASSET__HJm0gsc___"